import React from 'react';
import { Hint, Text } from 'components';
import { typography } from 'constants/styles';
import { Intent } from 'constants/ui';
import './MicroDepositsReadyHint.scss';
const MicroDepositsReadyHint = () => (React.createElement(Hint, { className: "micro-deposits-ready-hint", intent: Intent.INFO, multiline: true },
    React.createElement(Text.Semibold, { color: typography.TextColor.BLUE_BOLD, size: typography.TextSize.LEVEL_200 }, "You can verify your micro-deposits"),
    React.createElement(Text.Semibold, { color: typography.TextColor.BLACK, size: typography.TextSize.LEVEL_200 }, "It looks like your micro-deposits are ready, continue to verify your new Bank Transfer account.")));
export default MicroDepositsReadyHint;
